<template>
  <div class="page">
    <v-container fluid>

      <componente
        v-model="form.filters"
        :is="filtroPorCargoComponente"
        :lists="form.lists"
        @submit="buscarAcompanhamentoDeTurmas"
        ref="filtroDinamicoComponente"
      ></componente>

      <v-data-table
        class="mt-5"
        :headers="headersPorCargo"
        :items="form.lists.listAcompanhamentoDeTurmas"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="noDataText"
      >
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            text="Visualizar"
            icon="mdi-eye-outline"
            :small="true"
            @click="goToVisualizarAcompanhamento(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import AcompanhamentoDeTurmasService from '~/services/acompanhamento-de-turmas.service';
import SerieService from '~/services/serie.service';
import GreMunicipioService from '~/services/gre-municipio.service';
import TurnoService from '~/services/turno.service';
import LotacaoService from '~/services/lotacao.service';
import ProfissionalService from '~/services/profissional.service';
import FiltrosDeListagemAdministrador from './components/FiltrosDeListagemAdministrador.vue';
import FiltrosDeListagemArticuladorRegional from './components/FiltrosDeListagemArticuladorRegional.vue';
import FiltrosDeListagemArticuladorMunicipal from './components/FiltrosDeListagemArticuladorMunicipal.vue';

export default {
  name: "ManterAcompanhamentoDeTurmasView",
  components: {
    FiltrosDeListagemAdministrador,
    FiltrosDeListagemArticuladorRegional,
    FiltrosDeListagemArticuladorMunicipal,
  },
  mixins: [AcompanhamentoDeTurmasService, SerieService, TurnoService, LotacaoService, GreMunicipioService, ProfissionalService],
  data: () => ({
    form: {
      filters: {
        nomeDaTurma: null,
        anoSerie: null,
        turno: null,
        gre: null,
        municipio: null,
        escola: null,
      },
      lists: {
        listAcompanhamentoDeTurmas: [],
        listAnoSeries: [],
        listTurnos: [],
        listEscolas: [],
        listGres: [],
        listMunicipios: [],
        filteredListMunicipios: [],
        filteredListEscolas: [],
      },
      noDataText: '',
    },
    headers: {
      'Administrador': [
        { text: "Nome da Turma", align: "center", value: "nomeDaTurma", cellClass: 'text-wrap' },
        { text: "Ano/Série", align: "center", value: "anoSerie", cellClass: 'text-wrap' },
        { text: "Turno", align: "center", value: "turno", cellClass: 'text-wrap' },
        { text: "Escola", align: "center", value: "escola", cellClass: 'text-wrap' },
        { text: "Município", align: "center", value: "municipio", cellClass: 'text-wrap' },
        { text: "GRE", align: "center", value: "gre", cellClass: 'text-wrap' },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      'Articulador Regional': [
        { text: "Nome da Turma", align: "center", value: "nomeDaTurma", cellClass: 'text-wrap' },
        { text: "Ano/Série", align: "center", value: "anoSerie", cellClass: 'text-wrap' },
        { text: "Turno", align: "center", value: "turno", cellClass: 'text-wrap' },
        { text: "Escola", align: "center", value: "escola", cellClass: 'text-wrap' },
        { text: "Município", align: "center", value: "municipio", cellClass: 'text-wrap' },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      'Articulador Municipal': [
        { text: "Nome da Turma", align: "center", value: "nomeDaTurma" },
        { text: "Ano/Série", align: "center", value: "anoSerie" },
        { text: "Turno", align: "center", value: "turno" },
        { text: "Escola", align: "center", value: "escola" },
        { text: "Ações", align: "center", value: "acoes", sortable: false }
      ]
    }
  }),
  computed: {
    cargo() {
      return this.$route.params.cargo;
    },
    payload() {
      return { params: { ...this.form.filters } };
    },
    filtroPorCargoComponente() {
      switch (this.cargo) {
        case 'Administrador':
          return 'FiltrosDeListagemAdministrador';
        case 'Articulador Regional':
          return 'FiltrosDeListagemArticuladorRegional';
        case 'Articulador Municipal':
          return 'FiltrosDeListagemArticuladorMunicipal';
        default:
          return 'FiltrosDeListagemArticuladorMunicipal'; // fallback to Articulador Municipal
      }
    },
    headersPorCargo() {
      return this.headers[this.cargo] || [];
    },
  },  
  methods: {
    goToVisualizarAcompanhamento(item) {
      this.$router.push({
        name: 'Acompanhamento de Turma - Visualizar',
        params: { id: item.id }
      });
    },
    buscarAcompanhamentoDeTurmas() {
      this.noDataText = 'Não há registros a serem exibidos';
      this.$buscar(this.payload).then(({ data }) => {
        this.form.lists.listAcompanhamentoDeTurmas = data.lista;
      });
    },
    async redirectToAcompanhamentoDeTurmas() {
      const { data } = await this.$buscarCargo();
      const cargosPermitidos = ['Administrador', 'Articulador Regional', 'Articulador Municipal'];
      if (!cargosPermitidos.includes(data.cargo)) {
        return;
      }
      if (this.cargo !== data.cargo) {
        this.$router.push({
          name: 'Acompanhamento de Turmas - :cargo',
          params: { cargo: data.cargo }
        });
      }
    },
    inicializarMensagemDeListar() {
      if (['Administrador', 'Articulador Regional', 'Articulador Municipal'].includes(this.cargo)) {
        this.noDataText = '';
      } else {
        this.noDataText = 'Não há registros a serem exibidos';
      }
    }
  },
  async mounted() {
    await this.redirectToAcompanhamentoDeTurmas();
    this.$buscarSeries({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listAnoSeries = data.itens));
    this.$buscarTurnos({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listTurnos = data.itens));
    this.$buscarLotacoesPorPermissao({ params: { ativo: true, escola: true } }).then(({ data }) => {
      this.form.lists.listEscolas = data.resposta
      this.form.lists.filteredListEscolas = data.resposta
    });
    this.$buscarGreMunicipiosPorPermissao().then(({ data }) => {
      this.form.lists.listGres = data.resposta.gres;
      this.form.lists.listMunicipios = data.resposta.municipios;
      this.form.lists.filteredListMunicipios = data.resposta.municipios;
    });
    this.inicializarMensagemDeListar();
  }
};
</script>
